<tt-page *ngIf="!!setting">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <ng-container *ngTemplateOutlet="filters"></ng-container>
            <tt-button-goto ttText="stocktransfers_create_move" ttGoto="stocktransfercreate" [ttGotoParms]="{ stockplace_id: setting.stockplace_id }" ttIcon="far fa-plus"></tt-button-goto>
        </tt-card>

        <tt-list [ttData]="itemsListStockTransfers" [ttFilter]="setting.filtervalue"></tt-list>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <div class="col-xs-12 sp-0">
            <tt-card class="col-xs-12 col-md-4 p-5">
                <ng-container *ngTemplateOutlet="filters"></ng-container>
            </tt-card>

            <tt-card class="col-xs-12 col-md-2 p-5">
                <tt-button-goto ttText="stocktransfers_create_move" ttGoto="stocktransfercreate" [ttGotoParms]="{ stockplace_id: setting.stockplace_id }" ttIcon="far fa-plus"></tt-button-goto>
            </tt-card>
        </div>

        <tt-list class="col-xs-12 col-md-6 p-5" [ttData]="itemsListStockTransfers" [ttFilter]="setting.filtervalue"></tt-list>
    </div>
</tt-page>

<ng-template #filters>
    <ng-container *ngIf="!!setting">
        <tt-select ttRememberId="w_stocktransfers.businessco_no" ttLabel="businessco" [(ttModel)]="setting.businessco_no" (ttModelChange)="onChanged($event, 'businessco_no')" [ttData]="selectListCompanies" ttDataId="businessco_no" ttDataName="company_name"></tt-select>
        <tt-select [ttRememberId]="'w_stocktransfers.stockplace_id' + '.' + setting.businessco_no" ttLabel="stockplace" [(ttModel)]="setting.stockplace_id" (ttModelChange)="onChanged($event, 'stockplace_id')" [ttData]="selectListStockPlaces" ttDataId="stockplace_id" ttDataName="stockplace_name"></tt-select>
        <tt-input [ttRememberId]="'w_stocktransfers.filtervalue' + '.' + setting.stockplace_id" ttLabel="filtervalue" ttFocus="false" [(ttModel)]="setting.filtervalue" ttShowClearButton></tt-input>
    </ng-container>
</ng-template>
